<template>
	<div class="container-proposal">
		<section class="container-proposal-one">
			<ui-select-v2
				label="Entrada - (AT)"
				design="br-default"
				size="sm"
				type="text"
			/>

			<ui-select-v2
				label="Parcelas Mensais - (PM)"
				design="br-default"
				size="sm"
				type="text"
			/>
		</section>

        <section class="container-proposal-two">
			<ui-select-v2
				label="Parcelas Trimestrais - (PT)"
				design="br-default"
				size="sm"
				type="text"
			/>

			<ui-select-v2
				label="Parcelas Semestrais - (PS)"
				design="br-default"
				size="sm"
				type="text"
			/>
		</section>

        <section class="container-proposal-tree">
			<ui-select-v2
				label="Parcelas Anuais - (PA)"
				design="br-default"
				size="sm"
				type="text"
			/>

			<ui-select-v2
				label="Parcelas Intermediárias - (IN)"
				design="br-default"
				size="sm"
				type="text"
			/>
		</section>

		<section class="container-proposal-four">
			<ui-select-v2
				label="Comissões - (CO)"
				design="br-default"
				size="sm"
				type="text"
			/>
		</section>
	</div>
</template>

<script>
	import { uiSelectV2 } from '@/components/ui/form'

	export default {
		components: {
			uiSelectV2,
		},

		props: {
			id: {
				type: [Number,String],
				required: false,
				default: 0,
			},
			data: {
				type: Array,
				required: true
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
